export default __webpack_public_path__ + "static/media/TL03.1.3910ffaa.mp3";